import { render } from "./RibbonsBackground.vue?vue&type=template&id=4abd3f87&scoped=true"
import script from "./RibbonsBackground.vue?vue&type=script&lang=js"
export * from "./RibbonsBackground.vue?vue&type=script&lang=js"

import "./RibbonsBackground.vue?vue&type=style&index=0&id=4abd3f87&scoped=true&lang=css"

import exportComponent from "D:\\Project\\vblog\\vue-vblog\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4abd3f87"]])

export default __exports__